import { useLogger } from '@booksy-com/vue-tools'

export function registerCommonComponents ({ app }) {
  const logger = useLogger('registerCommonComponents')
  logger.debug('registering common components')

  // https://vitejs.dev/guide/features#glob-import
  const requireComponent = (() => {
    // only present if running vite
    return import.meta.glob(
      '../../../components/common/b-**.vue',
      {
        eager: true,
      }
    )
  })()

  // For each matching file name...
  Object.entries(requireComponent).forEach(([fileName, component]) => {
    // Get the PascalCase version of the component name
    const componentName = fileName
      // Remove the "./" from the beginning
      .replace(/^\.\//, '')
      // Remove the components/common/
      .replace(/^.*\/components\/common\//, '')
      // Remove the file extension from the end
      .replace(/\.\w+$/, '')
      // Split up kebabs
      .split('-')
      // Upper case
      .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
      // Concatenated
      .join('')

    // Globally register the component
    app.component(componentName, component.default || component)
  })
}
